import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext, useMemo } from 'react';
import { ApiKey } from '../../../../../../../../../typings/ApiKey.interface';
import { ApiKeyScopeFormValues, ApiKeyScopesFields, buildOrganizationApiKeyScopesPayload, organizationScopeProjectTypes, organizationScopeValuesFromApiKey } from '../../../../../common/ApiKeys/ApiKeyScopesFields';
import { ProjectAccessFields } from '../../../../../common/ApiKeys/ProjectAccessFields';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { DashboardContext } from '../../../DashboardContext';
interface FormValues extends ApiKeyScopeFormValues {
  project_access: string;
  project_ids: string[];
}
interface Props {
  api_key: ApiKey;
  onClose: () => void;
  onApiKeyUpdated: (api_key: ApiKey) => void;
}
const UpdateOrganizationApiKeyModal: React.FC<Props> = t0 => {
  const $ = _c(24);
  const {
    api_key,
    onClose,
    onApiKeyUpdated
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    team,
    teams
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  organization?.id;
  let t1;
  if ($[0] !== organization?.id || $[1] !== teams) {
    let t2;
    if ($[3] !== organization?.id) {
      t2 = org_team => org_team.organization_id === organization?.id;
      $[3] = organization?.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (teams ?? []).filter(t2).map(_temp);
    $[0] = organization?.id;
    $[1] = teams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const project_options = t1;
  const validate = _temp2;
  let t2;
  if ($[5] !== HookdeckAPI || $[6] !== addToast || $[7] !== api_key.id || $[8] !== onApiKeyUpdated || $[9] !== onClose || $[10] !== project_options) {
    t2 = async values_0 => {
      ;
      try {
        const updated_api_key = await HookdeckAPI.organizations.updateApiKey(api_key.id, buildOrganizationApiKeyScopesPayload(values_0, project_options));
        onApiKeyUpdated(updated_api_key);
        addToast("success", "API key updated");
        onClose();
      } catch (t3) {
        const err = t3;
        addToast("error", err.message);
      }
    };
    $[5] = HookdeckAPI;
    $[6] = addToast;
    $[7] = api_key.id;
    $[8] = onApiKeyUpdated;
    $[9] = onClose;
    $[10] = project_options;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const onSubmit = t2;
  let t3;
  if ($[12] !== api_key || $[13] !== project_options) {
    t3 = organizationScopeValuesFromApiKey(api_key, project_options);
    $[12] = api_key;
    $[13] = project_options;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== api_key.label || $[16] !== onClose || $[17] !== project_options || $[18] !== team?.id) {
    t4 = props => <form onSubmit={props.handleSubmit}><Modal title={`Update ${api_key.label ?? "Untitled"} API key`} submit_label="Update API key" cancel_label="Cancel" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}><Div flex={{
          direction: "column",
          gap: 4
        }}><ProjectAccessFields projects={project_options} current_project_id={team?.id} /><ApiKeyScopesFields tier="organization" project_types={organizationScopeProjectTypes(props.values, project_options)} /></Div></Modal></form>;
    $[15] = api_key.label;
    $[16] = onClose;
    $[17] = project_options;
    $[18] = team?.id;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== onSubmit || $[21] !== t3 || $[22] !== t4) {
    t5 = <Formik initialValues={t3} onSubmit={onSubmit} validate={validate} validateOnMount={true}>{t4}</Formik>;
    $[20] = onSubmit;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
};
export default UpdateOrganizationApiKeyModal;
function _temp(org_team_0) {
  return {
    id: org_team_0.id,
    name: org_team_0.name,
    type: org_team_0.type
  };
}
function _temp2(values) {
  const errors = {};
  if (values.project_access === "selected" && values.project_ids.length === 0) {
    errors.project_ids = "Select at least one project";
  }
  return errors;
}